import { useNavigate } from 'react-router-dom';
import { useLang } from '../LangContext';
import { useT } from '../i18n';
import LangSwitcher from '../components/LangSwitcher';

export default function SuccessCelebrationScreen() {
  const navigate = useNavigate();
  const { lang } = useLang();
  const t = useT(lang);

  return (
    <div style={{
      backgroundColor: '#3DBFA0',
      minHeight: '100dvh',
      display: 'flex',
      flexDirection: 'column',
      fontFamily: "'Be Vietnam Pro', sans-serif",
    }}>

      {/* TopBar — teal bg */}
      <header style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        maxWidth: 390, margin: '0 auto',
        height: 56, backgroundColor: '#3DBFA0',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '0 16px', zIndex: 50,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <button
            onClick={() => navigate(-1)}
            style={{ background: 'none', border: 'none', color: '#fff', cursor: 'pointer', padding: 4, borderRadius: '50%', display: 'flex' }}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
            </svg>
          </button>
          <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 700, color: '#ffffff' }}>
            <div style={{ fontSize: 18 }}>泡泡茶</div>
            <div style={{ fontSize: 10, opacity: 0.8, letterSpacing: '0.08em', textTransform: 'uppercase' }}>BubbleCha</div>
          </div>
        </div>
        <LangSwitcher />
      </header>

      <main style={{ flex: 1, paddingTop: 56, display: 'flex', flexDirection: 'column' }}>

        {/* ── Hero Celebration Zone ────────────────── */}
        <section style={{
          backgroundColor: '#3DBFA0',
          padding: '32px 24px 56px',
          display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center',
          position: 'relative', overflow: 'hidden',
        }}>
          {/* Decorative blobs */}
          <div style={{
            position: 'absolute', top: 0, left: 0,
            width: 128, height: 128,
            backgroundColor: 'rgba(255,255,255,0.1)',
            borderRadius: '50%',
            transform: 'translate(-50%, -50%)',
            filter: 'blur(32px)',
          }}/>
          <div style={{
            position: 'absolute', bottom: 0, right: 0,
            width: 192, height: 192,
            backgroundColor: 'rgba(131,254,220,0.2)',
            borderRadius: '50%',
            transform: 'translate(25%, 25%)',
            filter: 'blur(48px)',
          }}/>

          {/* Success badge */}
          <div style={{
            width: 96, height: 96,
            backgroundColor: '#ffffff',
            borderRadius: '50%',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            marginBottom: 24,
            position: 'relative', zIndex: 1,
          }}>
            <svg width="52" height="52" viewBox="0 0 24 24" fill="#3DBFA0" strokeWidth={0}>
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
            </svg>
          </div>

          <h1 style={{
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            fontWeight: 800, fontSize: 26, color: '#ffffff', marginBottom: 8,
            position: 'relative', zIndex: 1,
          }}>{t('congrats')}</h1>
          <p style={{
            fontSize: 14, fontFamily: "'Plus Jakarta Sans', sans-serif",
            color: 'rgba(255,255,255,0.85)', lineHeight: 1.6, maxWidth: 240,
            position: 'relative', zIndex: 1,
          }}>{t('capsuleReleased')}</p>

          {/* Decorative capsule graphic */}
          <div style={{
            position: 'absolute', bottom: -16, right: 16,
            width: 96, height: 96, transform: 'rotate(12deg)', opacity: 0.9, zIndex: 0,
          }}>
            {[...Array(5)].map((_, i) => (
              <div key={i} style={{
                position: 'absolute',
                width: 16 + i * 8, height: 16 + i * 8,
                borderRadius: '50%',
                backgroundColor: ['#f9cc61','#FF5C36','#3DBFA0','#ffffff','#ff7857'][i],
                top: i * 12, left: i * 12,
                opacity: 0.8,
              }}/>
            ))}
          </div>
        </section>

        {/* ── White content card ───────────────────── */}
        <section style={{
          flex: 1,
          backgroundColor: '#ffffff',
          borderRadius: '24px 24px 0 0',
          marginTop: -24,
          padding: '24px 24px 40px',
          zIndex: 20,
          boxShadow: '0 -8px 32px rgba(0,0,0,0.08)',
          display: 'flex', flexDirection: 'column',
        }}>
          {/* Reminder row */}
          <div style={{
            backgroundColor: '#FFF8E6',
            borderRadius: 12, padding: '12px 16px',
            display: 'flex', alignItems: 'center', gap: 10,
            marginBottom: 20,
          }}>
            <div style={{
              width: 8, height: 8, borderRadius: '50%',
              backgroundColor: '#FF5C36', flexShrink: 0,
            }}/>
            <span style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 700, fontSize: 12, color: '#8B5E3C',
            }}>{t('collectReminder')}</span>
          </div>

          {/* Transaction summary */}
          <div style={{
            backgroundColor: '#F5F4F0',
            borderRadius: 16, padding: 20, marginBottom: 16,
            border: '1px solid rgba(172,170,197,0.1)',
          }}>
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16,
            }}>
              <span style={{ fontSize: 13, color: '#5a5971', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                {t('thisRedemption')}
              </span>
              <span style={{
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800, fontSize: 13, color: '#2d2d42',
              }}>{t('gachaItem')}</span>
            </div>
            <div style={{ borderTop: '1px dashed rgba(172,170,197,0.3)', marginBottom: 16 }}/>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 13, color: '#5a5971', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  {t('pointsDeducted')}
                </span>
                <span style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800, fontSize: 14, color: '#b41340',
                }}>- 50 點</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontSize: 13, color: '#5a5971', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
                  {t('remainingPoints')}
                </span>
                <span style={{
                  fontFamily: "'Plus Jakarta Sans', sans-serif",
                  fontWeight: 800, fontSize: 14, color: '#3DBFA0',
                }}>1,200 點</span>
              </div>
            </div>
          </div>

          <p style={{
            fontSize: 12, color: '#5a5971', textAlign: 'center',
            fontFamily: "'Plus Jakarta Sans', sans-serif", marginBottom: 28,
          }}>{t('promoText')}</p>

          {/* Action buttons */}
          <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: 12 }}>
            <button
              onClick={() => navigate('/confirm?mode=points')}
              style={{
                height: 52, width: '100%',
                backgroundColor: '#FF5C36', color: '#ffffff',
                border: 'none', borderRadius: 12,
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800, fontSize: 15, cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(255,92,54,0.3)',
                transition: 'transform 0.15s',
              }}
            >{t('playAgain')}</button>

            <button
              onClick={() => {
                if (navigator.share) {
                  navigator.share({ title: '泡泡茶 BubbleCha', text: t('congrats'), url: window.location.href });
                }
              }}
              style={{
                height: 52, width: '100%',
                backgroundColor: 'transparent',
                border: '2px solid #3DBFA0', color: '#3DBFA0',
                borderRadius: 12,
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontWeight: 800, fontSize: 15, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
              }}
            >
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
              </svg>
              {t('shareExperience')}
            </button>

            <button
              onClick={() => navigate('/')}
              style={{
                height: 40, width: '100%',
                backgroundColor: 'transparent',
                border: 'none', color: '#5a5971',
                fontFamily: "'Be Vietnam Pro', sans-serif",
                fontSize: 13, cursor: 'pointer',
                transition: 'color 0.15s',
              }}
            >{t('returnHome')}</button>
          </div>
        </section>
      </main>

      <div style={{ height: 24, backgroundColor: '#ffffff' }}/>
    </div>
  );
}
